import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type LayoutDto = ClientInferResponseBody<typeof contract.layouts.findOne>;

export const fetchLayout = async (id: string) => {
  const response = await api.layouts.findOne.query({
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
